import * as React from 'react';
import Input from 'components/Input';
import { bindActionCreators, Dispatch } from 'redux';
// @ts-ignore
import { setQuery, SetQueryAction, Table as TableType, State as TableState } from 'reducers/tables';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

type Props = {
  namespace: string,
  placeholder: string,
  query: string,
  setQuery: (namespace: string, query: string) => SetQueryAction,
};

// This component uses a controlled component https://facebook.github.io/react/docs/forms.html#controlled-components
// We use this state to immediatly update the input, without having to wait for the debouncing to happen.
type State = {
  value: string,
};

class SmartTableSearchInput extends React.Component<Props, State> {
  state: State = {
    value: this.props.query,
  };
  debouncedChangeQuery = debounce(
    (query: string) => this.props.setQuery(this.props.namespace, query),
    400
  );

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ value: e.target.value });
    this.debouncedChangeQuery(e.target.value);
  };

  render() {
    return (
      <Input
        glyph="search"
        placeholder={this.props.placeholder}
        type="text"
        value={this.state.value}
        className="SmartTableSearchInput"
        onChange={this.onChange}
      />
    );
  }
}

function mapStateToProps(state: TableState, props: Props) {
  const table: TableType = state.tables.get(props.namespace);

  return {
    query: table.query,
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ setQuery: setQuery }, dispatch);
}

export { SmartTableSearchInput };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmartTableSearchInput);
